// Determine if we're in production based on hostname
const isProduction = window.location.hostname !== 'localhost';

// Set appropriate API URL based on environment
const apiUrlFallback = isProduction
  ? 'https://pnukxe2e4g.eu-west-1.awsapprunner.com/api'
  : 'http://localhost:8080/api';

const config = {
  // API services
  apiUrl: process.env.REACT_APP_API_URL || apiUrlFallback,
  baseUrl: process.env.REACT_APP_BASE_URL || 'https://dwelz.co.uk',
  crimesUrl: process.env.REACT_APP_CRIMES_URL || apiUrlFallback,
  oauthApiUrl: process.env.REACT_APP_API_OAUTH_URL || 'https://dwelz.co.uk/api',
  googleClientIdFallback: process.env.REACT_APP_GOOGLE_ID || "472292952560-a72m640bn6h67q4shapc4oj1bqeoh9rj.apps.googleusercontent.com",

  // Maps configuration
  maps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyBU74nJXPGTwsrA_0okArQXq5SCJAGD3Iw', // Fallback API key
    get hasValidKey() {
      const key = this.apiKey;
      return key && key !== 'YOUR_API_KEY_HERE';
    },

    // Google Maps options
    options: {
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: true,
      fullscreenControl: true,
    },
  },
};

// Add methods that reference the config object after it's defined
config.maps.getStaticMapUrl = (lat, lng, zoom = 16, width = 600, height = 400) => {
  return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=${width}x${height}&markers=color:red%7C${lat},${lng}&key=${config.maps.apiKey}`;
};

// OpenStreetMap fallback options
config.maps.openStreetMap = {
  // Generate embed URL for OpenStreetMap iframe
  getEmbedUrl: (lat, lng, zoom = 16) => {
    const margin = 0.01; // Approximately gives decent area around marker point
    return `https://www.openstreetmap.org/export/embed.html?bbox=${lng - margin},${lat - margin},${
      lng + margin
    },${lat + margin}&layer=mapnik&marker=${lat},${lng}`;
  },

  // Generate link to full OpenStreetMap
  getFullMapUrl: (lat, lng, zoom = 16) => {
    return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`;
  },
};

// Environment detection
config.isDevelopment = process.env.NODE_ENV === 'development';

// Logging configuration
config.logging = {
  level: process.env.REACT_APP_LOG_LEVEL || 'info',
  enableDebug: process.env.NODE_ENV === 'development',
};

export default config;
